/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tables_Contact_Code_Trees_TypeInputs */

const en_tables_contact_code_trees_type = /** @type {(inputs: Tables_Contact_Code_Trees_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

const de_tables_contact_code_trees_type = /** @type {(inputs: Tables_Contact_Code_Trees_TypeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type`)
};

/**
* | output |
* | --- |
* | "Type" |
*
* @param {Tables_Contact_Code_Trees_TypeInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const tables_contact_code_trees_type = /** @type {((inputs?: Tables_Contact_Code_Trees_TypeInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tables_Contact_Code_Trees_TypeInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_tables_contact_code_trees_type(inputs)
	return de_tables_contact_code_trees_type(inputs)
});